import React from "react";
import Box from "@mui/material/Box";

const ChartWrapper = ({ child, ...props }) => {
  return <Box sx={{ width: "100%", height: "380px", ...props }}>{child}</Box>;
};

export default ChartWrapper;
